import { useSelector } from 'react-redux';
import { AnimatronProject } from 'types/project';

import { videoFolderSelectors } from '../../../store/modules/videoFolder';

const useProjectData = (id?: string) => {
  const project = useSelector(
    state => id && videoFolderSelectors.selectProjectById(state, id)
  ) as AnimatronProject | null;

  const projectName = project?.name;
  const projectPreview = project?.preview_metadata[0]; // TODO: discuss preview to use

  return { projectName, projectPreview };
};

export default useProjectData;
